import { normalizeDigitInput } from '@/common/utils/normalizeDigitInput';
import { phoneNumberValidator } from '@/common/utils/phoneNumberValidator';

export function normalizeMobileNumber(value: string) {
  let digits = normalizeDigitInput(value.replace(/[٠-٩]/g, char => String(char.charCodeAt(0) - 0x660)));
  if (digits.startsWith('0098')) digits = digits.slice(4);
  else if (digits.startsWith('98')) digits = digits.slice(2);
  if (digits.startsWith('9')) digits = `0${digits}`;
  return digits;
}

export function mobileNumberError(value: string) {
  const number = normalizeMobileNumber(value);
  if (!number) return 'شماره موبایل خود را وارد کنید.';
  if (!number.startsWith('09')) return 'شماره موبایل باید با ۰۹ شروع شود.';
  if (number.length < 11) return 'شماره موبایل ناقص است؛ باید ۱۱ رقم باشد.';
  if (number.length > 11) return 'شماره موبایل بیش از ۱۱ رقم دارد؛ شماره را بررسی کنید.';
  if (!phoneNumberValidator(number)) return 'پیش‌شمارهٔ موبایل معتبر نیست؛ شماره را بررسی کنید.';
  return '';
}